export default "/images/placeholder.svg?ba8729a9d485e2aaab1b6570828bc8f9";